<ngb-alert class="banner" [type]="buttonBanner.type" [dismissible]="false">
  <div class="container-fluid">
    <!--
    <div class="row" *ngIf="banner.title">
      <div class="col">
        <label class="banner-title">{{banner.title}}</label>
      </div>
    </div>
    -->

    <div class="row align-items-center">
      @if (buttonBanner.bodyText) {
        <div class="col-auto">
          <label class="banner-body-text">{{ buttonBanner.bodyText }}</label>
        </div>
      }
      @for (BannerButton of buttonBanner.BannerButtons; track BannerButton) {
        <div class="col-auto">
          <button
            (click)="bannerButtonClick.emit(BannerButton.action)"
            [ngClass]="BannerButton.class"
            [ngStyle]="BannerButton.style"
          >
            {{ BannerButton.text }}
          </button>
        </div>
      }
    </div>
  </div>
</ngb-alert>
